import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ReportingPrintChartSlot from './ReportingPrintChartSlot';

/**
 * Off-screen host that renders charts at fixed dimensions for PDF capture.
 */
const ReportingPrintCapture = forwardRef(function ReportingPrintCapture({
    captureItems = [],
}, ref) {
    const slotRefs = useRef({});

    useImperativeHandle(ref, () => ({
        async captureAll() {
            const images = {};
            for (const item of captureItems) {
                const slotRef = slotRefs.current[item.id];
                if (!slotRef?.captureImage) continue;
                // eslint-disable-next-line no-await-in-loop
                const image = await slotRef.captureImage();
                if (image) images[item.id] = image;
            }
            return images;
        },
    }), [captureItems]);

    if (captureItems.length === 0) return null;

    return (
        <div
            aria-hidden
            style={{
                position: 'fixed',
                left: -10000,
                top: 0,
                width: 720,
                visibility: 'hidden',
                pointerEvents: 'none',
                zIndex: -1,
            }}
        >
            {captureItems.map(item => (
                <ReportingPrintChartSlot
                    key={item.id}
                    ref={(el) => {
                        if (el) slotRefs.current[item.id] = el;
                        else delete slotRefs.current[item.id];
                    }}
                    dataset={item.dataset}
                    vizSpec={item.vizSpec}
                />
            ))}
        </div>
    );
});

export default ReportingPrintCapture;
